module.exports = __webpack_public_path__ + "static/img2-0174e14ff48446a06a98984736fc06d3.jpg";